export default "__VITE_ASSET__DewKOdnP__"